<script>
  import Select from "./Select.svelte";
  import { afterUpdate,createEventDispatcher } from "svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  import { User } from "../../store.js";
  import { ExtractMsgsFromInvalidResponse } from "../Utils/UserMsgFromInvalidResponse.js";
  const dispatch = createEventDispatcher();

  let addressList = [];
  let filteredAdressList = [];
  let showAddressSearch = true;
  let showSelectedAddress = false;
  let address;
  let postcodeFormatted = "";
  let postCodeError = "";
  let addressError = "";
  let ErrorMessage = "";
  let postcodeInput;
  let focusInput=false;
  let laName=".";
  let isValidating = false;

  var user = "";
  if (u != null){
    user = u.username;
    //$User = u;
  }
  
  export let ArchievedAddress = false;
  export let selectedAddress;
  export let isRequired = false;
  export let isValid = true;
  export let isAddressDirty = false;
  export let isPostcodeDirty = false;
  export let postcode = "";
  export let isPostcodeValid = true;
  export let username = user; // ?? document.getElementById('username');

if (ArchievedAddress)
{
  ErrorMessage = "Please confirm your postcode, then search and select your address from the dropdown to continue.";
}

  const apiURL = "/addresses/getaddressbypostcode?user=" + username + "&postcode=";

  afterUpdate(()=>{
    if(focusInput){
      postcodeInput.focus();
      focusInput=false;
    }
  })

  const postcodeRegex = /^(GIR 0AA|[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2})$/i;

$: {
    if (isRequired && !selectedAddress && filteredAdressList.length>0) {
      isValid = false;
      ErrorMessage = "Please select an address from the drop down list";
    }
    else{
      if (selectedAddress)
      {
        isValid = true;
        ErrorMessage = "";
      }
    }

		if (selectedAddress) {
      if (selectedAddress.laName)
      {
        laName = "Local Authority: " + selectedAddress.laName;
      }
      else
      {
        if (found && found.length > 0)
        {
        let chosen = found.find(o => o.uprn === selectedAddress.uprn);
      }
    }
  }
 }

  let found  = [];

  const searchAddress = e => {
    isValidating = true;
    ErrorMessage = "";
    postcode = postcode.trim().replace(/\s+/g, ' ');
    postcode = postcode.replace(/(\S*)\s*(\d)/, "$1 $2");

    if (isRequired && postcode === "" && !selectedAddress) {
        isValid = false;
        isValidating = false;
        ErrorMessage = "Please enter your postcode";
    } 
    else if (isRequired && postcode.replace(/\s/g, "").length < 5 && !selectedAddress) {
        isValid = false;
        isValidating = false;
        ErrorMessage = "Postcode must be 5 characters or more (excluding spaces)";
    } 
    else if (isRequired && !postcodeRegex.test(postcode) && !selectedAddress) {
        isValid = false;
        isValidating = false;
        ErrorMessage = "Postcode is not valid or incomplete. Please enter the full postcode and try again";
    } 
    else {
        isValid = true;
    }

    e.preventDefault();

    if (isValid) {
        isPostcodeDirty = true;
        laName = "";
   
      wrappedFetch(apiURL + postcode)
        .then(res => res.json())
        .then(res => {
            if (res.success)
            {
                if (res.data.length > 0)
                {
                      let first = res.data[0];
                        found = res.data;
                        filteredAdressList = res.data.map(i =>
                        {
                            i.label = i.addr;
                            return i;
                        });
                        isPostcodeValid = true;
                        isValid = true;
                }
                else
                {
                      filteredAdressList = [];
                      ErrorMessage = "Postcode was not found. Please contact your home <a href='https://www.eadmissions.org.uk/contact/' target='_blank' style='text-decoration:underline'>Local Authority</a> for advice if the postcode entered is correct";
                      isValid = false;
                }
                isValidating = false;
            }
            else
            {
              filteredAdressList = [];
              ErrorMessage = res.message;
              if (ErrorMessage.includes("Internal Server Error")){
                ErrorMessage = "Postcode was not found. Please contact your home <a href='https://www.eadmissions.org.uk/contact/' target='_blank' style='text-decoration:underline'>Local Authority</a> for advice if the postcode entered is correct";
              }
              isValid = false;   
              isValidating = false;
            }
        });
    }
  };

  const editAddress = e => {
    e.preventDefault();
    filteredAdressList = [];
    isPostcodeDirty = false;
    isAddressDirty = false;
    selectedAddress = null;
    focusInput=true;

   // if (postcodeInput) postcodeInput.focus();
  };

  const checkMaxLength = e => {
    if (postcode.length >= 8) {
      //error = 'Too long to be a valid post code. Please recheck the postcode.'
      e.preventDefault();
      return false;
    }
  };
  
</script>
  <form>
{#if !selectedAddress}
  <div class="has-addons columns" style="margin-bottom: 0px;">
    <div class="column" >
      <input
        aria-label="postcode"
        type="text"
        class="input {!isPostcodeValid ? 'is-danger' : ''}"
        bind:this={postcodeInput}
        bind:value={postcode}
        on:keypress={checkMaxLength}
        on:focus={() => {
          filteredAdressList = [];
          isAddressDirty = false;
        }}
        placeholder="Postcode" />
    </div>
    <div class="column">
      <button class="button is-purple {isValidating ? "is-loading" : ""}" on:click={searchAddress} disabled={isValidating}>Search</button>
    </div>
  </div>
  <!-- { (!isValid && isPostcodeDirty )  ? 'is-danger' : ''} -->

  {#if filteredAdressList.length > 0}
    <div class="field">
      <Select
        items={filteredAdressList}
        bind:selected={selectedAddress}
        placeholder="Please Select Address"
        class="{ (!isPostcodeValid )  ? 'is-danger' : ''}"
        on:blur={() => {
          isAddressDirty = true;
          if (isRequired && !selectedAddress) {
            isValid = false;
            addressError = 'Please select an address';
          } else isValid = true;
        }}
        on:change={()=> dispatch('change')}
             />
    </div>
  {/if}
{/if}
{#if selectedAddress}
  <div class="field">
    <div class="control">
      {#each selectedAddress.addr.split(',') as addr}
        {addr}<br/>
      {/each}
    </div>
    <label for="laName" style="font-size:small; color:grey">{laName}</label>
    <div class="control">
      <button
        class="button is-default"
        style="background-color: #f1f1f1;"
        on:click={editAddress}>
        Edit
      </button>
    </div>
  </div>
{/if}

<!-- {#if !isPostcodeValid && isPostcodeDirty}
  <p class="help has-text-danger">{@html postCodeError}</p>
{/if}

{#if !isValid && isAddressDirty && addressError!=''}
  <p class="help has-text-danger">{@html addressError}</p>
{/if} -->

{#if !isValid && ErrorMessage!=''}
  <p class="help has-text-danger">{@html ErrorMessage}</p>
{/if}


</form>
